import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="error-page">
      <div className="empty_box">
        <div className="empty_box_content">
          <h2>Error 404</h2>
          <p>Page not found</p>
          <Link
            to="/"
            className="btn btn-outline"
          >
            Jump to dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
